import React from 'react';
import { Link } from 'react-router-dom';
import { parseTextWithMentions, getUniqueMentionedUsernames } from '@/utils/mentions';
import { useVerifyUsernames } from '@/hooks/use-mentions';
import { cn } from '@/lib/utils';

interface MentionTextProps {
  text: string;
  className?: string;
  mentionClassName?: string;
  onMentionClick?: (username: string) => void;
}

export const MentionText: React.FC<MentionTextProps> = ({
  text,
  className,
  mentionClassName,
  onMentionClick
}) => {
  // Extract all unique usernames from the text
  const usernames = getUniqueMentionedUsernames(text);
  
  // Verify which usernames actually exist
  const { data: usernameMap = {} } = useVerifyUsernames(usernames);
  
  // Parse text into segments
  const segments = parseTextWithMentions(text);
  
  return (
    <span className={className}>
      {segments.map((segment, index) => {
        if (!segment.isMention || !segment.username) {
          // Regular text
          return (
            <React.Fragment key={index}>
              {segment.text}
            </React.Fragment>
          );
        }
        
        // Check if username exists in database
        const userExists = usernameMap[segment.username.toLowerCase()];
        
        if (userExists) {
          // Clickable mention
          return (
            <Link
              key={index}
              to={`/profile/${segment.username}`}
              onClick={(e) => {
                if (onMentionClick) {
                  e.preventDefault();
                  onMentionClick(segment.username!);
                }
              }}
              className={cn(
                'font-medium text-primary hover:underline cursor-pointer',
                mentionClassName
              )}
            >
              {segment.text}
            </Link>
          );
        }
        
        // Non-existent user - render as plain text
        return (
          <span key={index} className="text-muted-foreground">
            {segment.text}
          </span>
        );
      })}
    </span>
  );
};
